import { BindingPath } from "./Core/CoreTypes";

export enum TooltipsResolveActionType {
    DisableOwnTooltip = "DISABLE_OWN_TOOLTIP",
    EnableOwnTooltip = "ENABLE_OWN_TOOLTIP",
    DisableOwnTooltipAttachment = "DISABLE_OWN_TOOLTIP_ATTACHMENT",
    EnableOwnTooltipAttachment = "ENABLE_OWN_TOOLTIP_ATTACHMENT",
}

export type TooltipsResolveAction =
    | {
          type: TooltipsResolveActionType.DisableOwnTooltip;
          payload: {
              bindingPaths: BindingPath[];
              errorId: string;
          };
      }
    | {
          type: TooltipsResolveActionType.EnableOwnTooltip;
      }
    | {
          type: TooltipsResolveActionType.DisableOwnTooltipAttachment;
          payload: {
              bindingPaths: BindingPath[];
              errorId: string;
              attachmentId?: string;
              highlanderPath?: string;
          };
      }
    | {
          type: TooltipsResolveActionType.EnableOwnTooltipAttachment;
      };
